import {
  DlpKeywordListModalNameEnum,
  DlpKeywordListModalState,
} from '../../type';
import { DeleteModal } from './delete';
import { EditOrAddModal } from './editOrAdd';
import { ImportModal } from './import';

export const KeywordModal = ({
  modalState,
  onClose,
  refreshTable,
}: {
  modalState: DlpKeywordListModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  if (modalState.name === DlpKeywordListModalNameEnum.Delete) {
    return (
      <DeleteModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }

  if (
    modalState.name === DlpKeywordListModalNameEnum.Add ||
    modalState.name === DlpKeywordListModalNameEnum.Edit
  ) {
    return (
      <EditOrAddModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }

  if (modalState.name === DlpKeywordListModalNameEnum.Import) {
    return (
      <ImportModal
        modalState={modalState}
        onClose={onClose}
        refreshTable={refreshTable}
      />
    );
  }
  return <></>;
};
